import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'

export function useMaximumPreparationTime () {
  function maximumPreparationTime (orderItems) {
    return _(orderItems.data)
      .filter(orderItem => orderItem.type === ORDER_ITEM_TYPES.ITEM)
      .map('item.preparationTimeMinutes')
      .max() || 0
  }

  return {
    maximumPreparationTime
  }
}
